import React from "react";
import { Link } from "react-router-dom";

const ServicesItem = ({ service }) => {
  const { id, title, description, image } = service;
  const slug = title
    .toLowerCase()
    .replace(/[^\w ]+/g, "")
    .replace(/ +/g, "-");
  return (
    <>
      <div className="hover:shadow-lg bg-white px-4 py-4">
        <div className="rounded-md overflow-hidden h-48 bg-gray-100">
          <img src={image} alt="" className="w-full h-full object-cover" />
        </div>
        <div>
          <h1 className="text-2xl text-center font-Poppins py-4 text-secondary">
            <Link to={`/service/${id}/${slug}`}>{title}</Link>
          </h1>
          <p>{description.slice(0, 110)}...</p>
        </div>
      </div>
    </>
  );
};

export default ServicesItem;
